import { formatCurrency } from "../../../../../../components/common/Converter";
import InputFactory from "../../../../../../components/InputFactory";
import "../../../../../../components/common/TablePayrollForm.css";
export const formatDeductions = (type, keys, rIndex, csvEntry) =>
  keys.map((key, j) => (
    <td key={`${type}-${rIndex}-${j}`}>
      {csvEntry && csvEntry[key.trim()] !== undefined
        ? formatCurrency(csvEntry[key.trim()].toString())
        : ""}
    </td>
  ));

export const renderInputField = (
  type,
  field,
  values,
  item,
  dynamicOnChange
) => {
  console.log("dynamicOnChange", dynamicOnChange);
  return (
    <InputFactory
      className={field === "peraAda" ? "custom-input custom" : "custom-input"}
      type={type}
      field={field}
      value={values || ""}
      onChange={(value) => dynamicOnChange(item.id, value)}
    />
  );
};
export const isUpdateNeeded = ({ newValue, currValue, isArray }) => {
  if (isArray) {
    if (newValue.length !== currValue.length) return true;
    for (let i = 0; i < newValue.length; i++) {
      if (newValue[i] !== currValue[i]) return true;
    }
    return false;
  }
  return newValue !== currValue;
};

export const renderDynamicFields = (field, fieldData, tdStyle) => {
  return Array.from({ length: fieldData.length }, (_, index) => (
    <td style={tdStyle} key={`${field}-${index}`}></td>
  ));
};
